import React from 'react';
import { FiBook } from 'react-icons/fi';

const TopicContent = ({ content }) => {
  return (
    <>
      {content.sections && content.sections.map((section, index) => (
        <div key={index} className="content-section">
          <h2 className="section-title">
            <FiBook />
            {section.title}
          </h2>
          <div className="section-content">
            {section.content}
          </div>
        </div>
      ))}
    </>
  );
};

export default TopicContent;

